var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.lazyDom)?_vm._t("default"):(!_vm.lazyDom && _vm.notLoading)?_c('div'):_c('div',{staticClass:"text-center blue icon-loading-size"},[_c('i',{staticClass:"el-icon-loading"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }